var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "solutions" },
    [
      _c(
        "h2",
        [
          _c("masked-image", {
            staticClass: "icon_title",
            attrs: { src: "/img/icons/price.svg" }
          }),
          _vm._v(
            "\n             " +
              _vm._s(_vm._f("capitalize")(_vm.lang.title)) +
              "\n        "
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "solution-list" },
        [
          _vm._l(_vm.solutions, function(solution, index) {
            return [
              _c(
                "div",
                {
                  key: "data-" + solution.id,
                  staticClass: "row align-items-center"
                },
                [
                  solution.media.images[0]
                    ? _c("div", {
                        staticClass: "solutions_list_image col-sm-2",
                        style:
                          "background-image: url(" +
                          solution.media.images[0]["url"]["gallery_preview"] +
                          ")",
                        on: {
                          click: function($event) {
                            return _vm.showSolutionsImage(index)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-3" }, [
                    _c("div", { staticClass: "solution-title" }, [
                      _vm._v(_vm._s(solution.subtype))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "current-price" }, [
                      _vm._v("€ " + _vm._s(solution.price))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-sm-7 solution-data" },
                    [
                      _c(
                        "span",
                        { staticClass: "estate-card-surface" },
                        [
                          _c("masked-image", {
                            attrs: { src: "/img/icons/surface.svg" }
                          }),
                          _vm._v(
                            " " +
                              _vm._s(solution.surface) +
                              " " +
                              _vm._s(_vm._f("capitalize")(_vm.lang.surface))
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      solution.floor != null
                        ? _c(
                            "span",
                            { staticClass: "estate-card-floor" },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/floor.svg" }
                              }),
                              _vm._v(
                                "  " +
                                  _vm._s(solution.floor) +
                                  " " +
                                  _vm._s(_vm._f("capitalize")(_vm.lang.floor))
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "solution-info",
                            on: {
                              click: function($event) {
                                return _vm.toggleDescription(solution.id)
                              }
                            }
                          },
                          [
                            _c("masked-image", {
                              attrs: { src: "/img/icons/info-circle.svg" }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "modal-opener",
                        {
                          attrs: {
                            name: "solution-lead",
                            data: { solutionId: solution.id }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "solution-lead" },
                            [
                              _c("masked-image", {
                                attrs: { src: "/img/icons/email.svg" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.descriptionIsShown(solution.id)
                    ? _c(
                        "div",
                        {
                          key: "description-" + solution.id,
                          staticClass: "col-12 p-0"
                        },
                        [
                          _c("div", { staticClass: "well" }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(solution.description)
                              }
                            })
                          ])
                        ]
                      )
                    : _vm._e()
                ]
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("modal", {
        ref: "solution-lead",
        attrs: {
          name: "solution-lead",
          "extra-class": "full-screen-modal solution-lead-modal",
          title: _vm.trans("lead"),
          icon: "email.svg"
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function(props) {
              return [
                _c("lead-form", {
                  attrs: {
                    estate: _vm.estate,
                    "solution-id": props.data.solutionId
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }